import * as React from "react"
import createSvgIcon from "./utils/create_icon"

const ArchiveFill = createSvgIcon(<React.Fragment><g fill="currentColor"><path d="M8 3a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zM6 7a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2z" /><path clipRule="evenodd" d="M4 11a1 1 0 0 0-.97 1.243l2 8A1 1 0 0 0 6 21h12a1 1 0 0 0 .97-.757l2-8A1 1 0 0 0 20 11zm5 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1z" fillRule="evenodd" /></g></React.Fragment>, "ArchiveFill")
export default ArchiveFill
